import {
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";

const StatutoryDetailsFields = ({ formData, handleFormDataChange, statusList }) => {
    const panValue = formData.pan_no || "";
    const isPanInvalid = panValue !== "" && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(panValue);
    const gstValue = formData.gst_no || "";
    const gstOptionalStatuses = new Set([
        "individual",
        "proprietor",
        "state govt department",
        "centre govt department",
    ]);
    const selectedStatusTitle = (
        statusList.find((status) => String(status.id) === String(formData.status))?.title || ""
    ).trim().toLowerCase();
    const isGstOptional = gstOptionalStatuses.has(selectedStatusTitle);
    const isGstInvalid = gstValue !== "" && !/^\d{2}[A-Z]{5}\d{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/.test(gstValue);

    const handleSelectChange = (fieldName) => (event) => {
        handleFormDataChange({
            target: {
                name: fieldName,
                value: event.target.value,
            },
        });
    };

    return (
        <div className="row">
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="PAN *"
                        name="pan_no"
                        value={formData.pan_no || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 10 }}
                        error={isPanInvalid}
                        helperText={isPanInvalid ? "Please enter a valid PAN (e.g., ABCDE1234F)." : ""}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="PAN Holder Name *"
                        name="pan_holder_name"
                        value={formData.pan_holder_name || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 50 }}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <InputLabel id="beneficiary-status-label">Status *</InputLabel>
                    <Select
                        labelId="beneficiary-status-label"
                        id="status"
                        name="status"
                        value={String(formData.status || "")}
                        label="Status *"
                        onChange={handleSelectChange("status")}
                    >
                        <MenuItem value="">---Select Status---</MenuItem>
                        {statusList.map((status) => (
                            <MenuItem value={String(status.id)} key={status.id}>
                                {status.title}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label={isGstOptional ? "GST No" : "GST No *"}
                        name="gst_no"
                        value={formData.gst_no || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 15 }}
                        error={isGstInvalid}
                        helperText={isGstInvalid ? "Please enter a valid GST No (e.g., 22ABCDE1234F1Z5)." : ""}
                    />
                </FormControl>
            </div>
            <div className="col-md-4 p-2">
                <FormControl fullWidth>
                    <TextField
                        label="Reg No. MSME Act, 2006"
                        name="reg_no"
                        value={formData.reg_no || ""}
                        onChange={handleFormDataChange}
                        inputProps={{ maxLength: 19 }}
                    />
                </FormControl>
            </div>
        </div>
    );
};

export default StatutoryDetailsFields;